<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        11.29
        <br />2017
      </span>
      <span class="tiel">美菜连续三年参加世界互联网大会，三大看点提前看！</span>
    </div>

    <div class="mat-content">
      <div class="tet-js">
        12月3日至5日，第四届世界互联网大会将在浙江乌镇举行。本届大会将以“发展数字经济促进开放共享，携手共建网络空间命运共同体”为主题，在全球范围内邀请互联网领军人物。
        <br />
        <br />自2015年起已连续三届参加互联网大会的美菜网，此次又将会带来哪些精彩看点呢？
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/b9_01.jpg" width="640" />
      </p>
    </div>

    <div class="mat-content">
      <div class="title-bold">
        <span></span>看点一：美菜网CEO刘传军将与蒙牛、三星等全球500强企业一同探讨精准扶贫等实质问题
      </div>
      <div class="tet-js">
        本届互联网大会将开设以“共享红利：互联网精准扶贫”为主题的分论坛，论坛将邀请来自国际组织、政府、企业家、专家代表，分享互联网精准扶贫的政策措施和典型案例。
        <br />
        <br />作为农业互联网企业的代表，美菜网创始人刘传军将与蒙牛、三星等全球500强企业一同探讨精准扶贫、农业发展、农民增收等实质问题。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/b9_02.jpg" width="640" />
      </p>
    </div>

    <div class="mat-content">
      <div class="title-bold">
        <span></span>看点二：美菜网将展示三年来技术成果和发展路径。
      </div>
      <div class="tet-js">
        在过去的三年多时间里，美菜网全面布局，覆盖全国近50个城市，估值已超过30亿美金，已经成为国内知名的农产品移动电商平台。截至2017年9月，美菜日包裹处理量超过100万个，配送次数已超3000万次，累计已服务过的商户超过100万家。 预计到2017年底，美菜网农产品上行将超过百亿元规模，其中，果蔬产品将超过8亿斤。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/b9_03.jpg" width="640" />
      </p>
    </div>

    <div class="mat-content">
      <div class="title-bold">
        <span></span>看点三：美菜网脱贫主义，响应精准扶贫的号召，帮扶贫困地区的项目成果
      </div>
      <div class="tet-js">
        随着美菜模式的深入推广，也有越来越多的城里人带着城市的资源和思路返乡创业。今年5月，美菜网积极响应精准扶贫的号召，发起助销扶贫菜的公益项目。陆续在安徽、河北、内蒙、四川、山东等贫困地区帮扶采购圆葱、土豆、西瓜、卷心菜、胡萝卜等农产品近400万斤。
        <br />
        <br />其中，在老震区北川我们帮扶采购了高山萝卜。种萝卜老农的儿子在城市工作，在了解美菜的模式后，毅然辞去城市的工作返乡投身农业，希望用互联网思维，带领一方村民致富。
        <br />
        <br />除了这些，现场还会有其他看点，具体就让我们一起关注美菜在第四届世界互联网大会的精彩表现吧！
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
